import React, { lazy, Suspense } from 'react'
import './ProductList.css';

import { ProductList } from './ProductList'
// const ProductList = lazy(() =>
//   import('./ProductList').then(module => ({ default: module.ProductList }))
// );//Dyanmic importing of componenet
export const ProductListing = () => {
  return (
    <>
    {/* <Suspense fallback={
       <div className="loaderDiv">
       <h2> loadding</h2>
       </div>
    }> */}
      <ProductList/>
    {/* </Suspense>   */}
    </>
  )
}
